import {dqs} from '../lib/util'
import {login as auth0_login} from '../lib/authentication'

export const login = async () => {
  dqs('main > section#login button').onclick = auth0_login
}
